import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrayMapPipe } from './array-map.pipe';
import { ArrayFilterPipe } from './array-filter.pipe';

@NgModule({
  declarations: [ArrayMapPipe, ArrayFilterPipe],
  imports: [
    CommonModule
  ],
  exports: [ArrayMapPipe, ArrayFilterPipe]
})
export class NgxCmFiltersModule { }
